export enum DataType { VARCHAR2 = 1, NUMBER = 2, DATE = 12, ADN_SELF_OBJECT = 108, CLOB = 112 }